export const POLYLINE_STROKE_WEIGHT = 5;
export const POLYLINE_STROKE_COLOR = '#1890ff';
export const POLYLINE_STROKE_OPACITY = 0.8;

export const MIN_ZOOM_FOR_NAVIGATION = 16;
export const SELECTED_DRIVER_ZOOM = 15;
export const STOP_CLUSTERING_ZOOM = 18;

export const POLLING_INTERVAL_MS = 30000;

export const GEO_EVENT_HIGHLIGHT_SIZE = 42;
export const GEO_EVENT_HIGHLIGHT_ICON_SIZE = 22;
export const GEO_EVENT_HIGHLIGHT_BORDER_WIDTH = 3;
export const GEO_EVENT_HIGHLIGHT_PULSE_COLOR = '#ff4d4f';
export const GEO_EVENT_HIGHLIGHT_PULSE_DURATION_MS = 1500;
export const GEO_EVENT_HIGHLIGHT_Z_INDEX = 2000;

export const GEO_EVENT_MARKER_SVG_SIZE = 24;
